module.exports = __webpack_public_path__ + "img/icon-monitor.73956f7c.svg";